export default {
	data() {
		return {
			monthNames: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
			dayOfWeekNames: ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
			collectiveAgreements: [],//required for mutateReport() method
			userNoteToggle: {}, //required for mutateReport() method
			userNotes: [], //required for mutateReport() method
			totalHrsByDay: {}, //required for mutateReport() method
			unionList: [], //required for mutateReport() method
		}
	},
	computed: {
		defaultDateFromFilter() {
			if (this.$store.timeLogSettings && "initial_payday" in this.$store.timeLogSettings && "interval" in this.$store.timeLogSettings) {

				let startDate = this.findPayRollStartDay(this.moment().format("YYYY-MM-DD"),this.$store.timeLogSettings.interval,this.$store.timeLogSettings.initial_payday)

				return this.moment(startDate).format("YYYY-MM-DD")
			}

			return this.moment().format("YYYY-MM-DD")
		}
	},
	methods: {
		//returns the first day of the payroll period that givenDate (ate string YYYY-MM-DD) falls into 
		findPayRollStartDay(givenDate, interval, initial_payday) {

			let vm = this

			//get first day of pay period
			let dayInterval = false;
			let monthlyInterval = false

			if (interval == "weekly")
				dayInterval = 7
			else if (interval == "biweekly")
				dayInterval = 14
			//else if (this.timeLogSettings	.interval == "semimonthly")
			//	monthlyInterval = 0.5
			else if (interval == "monthly")
				monthlyInterval = 1
			else if (interval == "semimonthly") {
				dayInterval = 15
			}

			if (this.moment(givenDate).isBefore(this.moment(initial_payday))) {
				// initial payday is after the given date, so we need to walk it back

				let adjustedInitialPayday = this.moment(initial_payday)

				while (this.moment(givenDate).isBefore(adjustedInitialPayday)) {
					if (monthlyInterval) 
						adjustedInitialPayday = adjustedInitialPayday.subtract(monthlyInterval,"months")
					else if (dayInterval)
						adjustedInitialPayday = adjustedInitialPayday.subtract(dayInterval,"days")
				}
				

				initial_payday = adjustedInitialPayday.format("YYYY-MM-DD")
			}

			let d = new Date(this.moment(initial_payday).local())

			let givenDateLessInterval
			if (givenDate) 
				givenDateLessInterval = new Date(this.moment(givenDate).local())
			
			else
				givenDateLessInterval = new Date(this.moment())

			//figure out day 1 of payroll period
			if (dayInterval) {
				
				if (interval == "semimonthly") {
					//special case because semi-monthly intervals will not always be 15 days apart

					//pay days will always be on the same day of month for each month (ie 1st and 16th, or 3rd and 18th, etc)
					/*
					1. Figure out if start date is in first half of month
					2. If so we can take that and add 15 to get the second pay day
					3. Else take that and subtract 15 to get first pay day
					*/

					let paydays = {}
					if (d.getDate() < 16) {

						paydays = {
							first: d.getDate(),
							second: d.getDate() + 15
						}
					}
					else {
						//second half of month

						paydays = {
							first: d.getDate() - 15,
							second: d.getDate()
						}
					}

					//figure out if most recent payday is first or second of month
					let start_date
					let month = new Date(givenDateLessInterval).getMonth() + 1
					if (givenDateLessInterval.getDate() < paydays.first) {
						//second date of last month
						let this_month = new Date(givenDateLessInterval.getFullYear() + "-" + month + "-" + paydays.second);

						//now subtract 1 month
						return new Date(vm.moment(this_month).subtract(1,"months"))

					}
					else {
						//now check if givenDate is greater than second date

						if (givenDateLessInterval.getDate() >= paydays.second) {
							//second pay of this month
							return new Date(givenDateLessInterval.getFullYear() + "-" + month + "-" + paydays.second)
						}
						else {
							//first pay of this month
							return new Date(givenDateLessInterval.getFullYear() + "-" + month + "-" + paydays.first)
						}
					}
				}
				else {

					givenDateLessInterval.setDate(givenDateLessInterval.getDate() - dayInterval)

					let bailoutCount = 1000;

					let cnt = 0

					//iterate until we're within the interval of givenDate
					while (d <= givenDateLessInterval) {
						d.setDate(d.getDate() + dayInterval)
						cnt++

						if (bailoutCount < cnt) {
							break
						}
					}
					
					//d should now be first day of current payroll
					d.setDate(d.getDate())

					return d
				}

			}
			else if (monthlyInterval) {
				
				givenDateLessInterval.setMonth(givenDateLessInterval.getMonth() - monthlyInterval)

				//iterate until we're within the interval of today
				while (d < givenDateLessInterval) {
					d.setMonth(d.getMonth() + monthlyInterval)
				}

				//d should how be first day of current payroll
				d.setDate(d.getDate() + 1)

				return d
			}
		},
		findNumDaysinPayPeriod(givenDate,interval,initial_payday) {
			//get number of days in the pay period


			let numDays = 0;
			if (interval == "weekly")
				numDays = 7
			else if (interval == "biweekly")
				numDays = 14
			else if (interval == "monthly") {
				let start = this.findPayRollStartDay(givenDate,interval,initial_payday)
				let end = this.findPayRollStartDay(givenDate,interval,initial_payday)
				end.setMonth(end.getMonth() + 1)

				numDays = this.dateDiff(start,end)
			}
			else if (interval == "semimonthly") {
				let start = this.findPayRollStartDay(givenDate,interval,initial_payday)

				if (start.getDate() < 15) {
					//number of days is definitely 15
					return 15
				}
				else {
					//we need to find num of days to next pay period
					
					//let nextPayrollStart = this.findPayRollStartDay(this.moment(givenDate).add(17,"days"),interval,initial_payday)
					
					//return this.dateDiff(start,nextPayrollStart, "days") + 1

					let daysInMonth = this.moment(givenDate).daysInMonth()

					return daysInMonth - 15
					
				}
			}
			return numDays
		},
		mutateLogsToPayPeriods(logs,payPeriodInterval,initial_payday) {

			////////////////////////////////////////////////////////////////////////
			// mutateLogsToPayPeriods() takes array of logs and returns the following structure:
			/**
			*[
			*	{
			*		label: "Feb 12 to Feb 19",
			*		start: YYYY-MM-DD,
			*		end: YYYY-MM-DD,
			*		openLogs: [],
			*		orphanedLogs: [], //catchall for any job that was not assigned to user/job
			*		jobs: [
			*			{
			*				id: 1,
			*				type: 'service'/'project',
			*				job_name: "job name",
			*				job_num: "001-01",
			*				slug: 'string',
			*				reviewable: true,
			*				customerName: string,
			*				pays_mileage: boolean,
			*				pays_perdiem: boolean,
			*				users: [
			*					{
			*						id: 1,
			*						fullName: "Bob Test",
			*						unionName: string,
			*						showUserLogsPanel: false/true
			*						totals: {
			*							regular_hours: 0,
			*							overtime_hours_15x: 0,
			*							overtime_hours_2x: 0,
			*							overtime_hours_25x: 0,
			*							total: 0,
			*							otherJobs: {
			*								regular_hours: 0,
			*								overtime_hours_15x: 0,
			*								overtime_hours_2x: 0,
			*								overtime_hours_25x: 0,
			*								total: 0
			*							},
			*							allJobs: {
			*								regular_hours: 0,
			*								overtime_hours_15x: 0,
			*								overtime_hours_2x: 0,
			*								overtime_hours_25x: 0,
			*								total: 0
			*							},
			*						},
			*						days: [
			*							{
			*								date: YYYY-MM-DD,
			*								label: "Mon Feb 12",
			*								logs: [
			*									{log}
			*								]
			*							}
			*						]
			*					}
			*				]
			*			}
			*		]
			*	}
			*]
			**/
			let vm = this

			if (logs.length == 0) 
				return []

			let jobs = []
			logs.forEach(log => {
				if ("Job" in log && log.Job) {
					log.Job.type = "project"
					jobs.push(log.Job)
				}
				else if ("Service" in log && log.Service) {
					log.Service.type = "service"
					jobs.push(log.Service)
				}
			})

			let payPeriods = []

			let orphanedLogs = []

			logs.forEach(log => {

				if (log.User && (!("EmployeeSetting" in log.User) || log.User.EmployeeSetting.length == 0 || log.User.EmployeeSetting[0].is_salary == 0)) {

					let logAssigned = false

					//get first day of pay period
					let logAsLocal = vm.moment.utc(log.time_in).local().format("YYYY-MM-DD HH:mm:ss")

					let periodStartDate = vm.findPayRollStartDay(logAsLocal,payPeriodInterval,initial_payday)
					let periodEndDate = new Date(periodStartDate)

					let daysInPeriod = vm.findNumDaysinPayPeriod(logAsLocal,payPeriodInterval,initial_payday)

					let logPeriodStart = vm.formatDate(vm.findPayRollStartDay(logAsLocal,payPeriodInterval,initial_payday))


					periodEndDate.setDate(periodStartDate.getDate() + daysInPeriod)

					//check to see if this log's period already exists in payPeriods array
					let payPeriodFound = false
					payPeriods.forEach(period => {

						if (period.start == logPeriodStart) {

							payPeriodFound = true
							//found so search for jobs
							let jobFound = false

							//if log is open, add it to open logs list
							if (log.time_out == "0000-00-00 00:00:00") {
								logAssigned = true
								period.openLogs.push(log)
							}

							else {

								period.jobs.forEach(job => {

									if ((job && job.id == log.job_id && job.type == "project") || (job && job.id == log.service_id && job.type == "service")) {
										//job found, search for users
										jobFound = true
										//found, so search users
										let userFound = false

										job.users.forEach(user => {
											if (user.id == log.user_id) {
												//user found, search user's days and add log to that day's logs
												userFound = true

												user.days.forEach(day => {
													let logLocalDate = vm.moment.utc(log.time_in).local().format("MMM D, YYYY")

													if (day.date == logLocalDate) {
														//this is the day the log belongs to, so add some mutations and push to the day's logs array
															
														log.timeOnlyIn = vm.formatDateTimeToLocal(log.time_in,'time')
														log.timeOnlyOut = vm.formatDateTimeToLocal(log.time_out,'time')

														day.logs.push(log)

														logAssigned = true

														//add to the user total
														user.totals.regular_hours += +log.regular_hours
														user.totals.overtime_hours_15x += +log.overtime_hours_15x
														user.totals.overtime_hours_2x += +log.overtime_hours_2x
														user.totals.overtime_hours_25x += +log.overtime_hours_25x
														
														user.totals.total += parseFloat(log.regular_hours) + parseFloat(log.overtime_hours_15x) + parseFloat(log.overtime_hours_2x) + parseFloat(log.overtime_hours_25x)
													}
												})
											}
										})
										if (!userFound) {

											//create user within this pay period
											let days = vm.createNewDayObj(periodStartDate, daysInPeriod, log)

											logAssigned = true

											let user = vm.createNewUserObj(log,days)

											if (user)
												job.users.push(user)
										}
									}
								})
								if (!jobFound) {
									//push new job

									let days = vm.createNewDayObj(periodStartDate, daysInPeriod, log)

									logAssigned = true

									let job = vm.createNewJobObj(jobs,log,days)

									if (job)
										period.jobs.push(job)
								}
							}
							
						}
					})
					if (!payPeriodFound) {

						let days = vm.createNewDayObj(periodStartDate, daysInPeriod, log)

						let startDate = new Date(periodStartDate)

						let endDate = new Date(periodEndDate)

						endDate.setDate(endDate.getDate() - 1)

						let labelStart = vm.monthNames[startDate.getMonth()] + " " + startDate.getDate()

						let labelEnd = vm.monthNames[endDate.getMonth()] + " " + endDate.getDate()

						let openLogs = []
						let jobsList = []

						logAssigned = true

						if (log.time_out == "0000-00-00 00:00:00")
							openLogs = [log]
						else {
							let job = vm.createNewJobObj(jobs,log,days)

							if (job)
								jobsList = [job]
						}

						payPeriods.push({
							label:  labelStart + " to " + labelEnd,
							start: vm.formatDate(periodStartDate),
							end: vm.formatDate(periodEndDate),
							openLogs: openLogs,
							jobs: jobsList,
							numDays: daysInPeriod
						})
					}

					if (!logAssigned || (!log.Service && !log.Job)) {
						//this log is orphaned somehow
						orphanedLogs.push(log)
					}
				}
				
			})

			payPeriods.forEach(period => {
				period.orphanedLogs = []

				//orphaned logs
				orphanedLogs.forEach(log => {
					let logPeriodStart = vm.formatDate(vm.findPayRollStartDay(log.time_in,payPeriodInterval,initial_payday))

					if (logPeriodStart == period.start) 
						period.orphanedLogs.push(log)
					
				})

				period.jobs.sort((a,b) => {
					if (a.reviewable && b.reviewable || !a.reviewable && !b.reviewable)
						return -1 //keep sort order the same
					else {
						if (!a.reviewable && b.reviewable)
							return 1
						else
							return -1
					} 

				})
			})

			//compiled user specifc totals for jobs, other jobs, and grand total
			let hourTypes = [
				"regular_hours",
				"overtime_hours_15x",
				"overtime_hours_2x",
				"overtime_hours_25x"
			]

			payPeriods.forEach(period => {
				if ("jobs" in period && period.jobs) {
					period.jobs.forEach(job => {
						if (job && "users" in job && job.users) {
							job.users.forEach(user => {

								user.totals.allJobs = {}
								user.totals.otherJobs = {}

								hourTypes.forEach(type => {
									user.totals.allJobs[type] = 0
									user.totals.otherJobs[type] = 0
								})

								user.totals.allJobs.total = 0
								user.totals.otherJobs.total = 0

								period.jobs.forEach(innerJob => {

									let userRecord = innerJob.users.find(innerUser => innerUser.id == user.id)

									if (userRecord) {
										hourTypes.forEach(type => {

											if (!(type in user.totals.allJobs))
												user.totals.allJobs[type] = 0

											if (!(type in user.totals.otherJobs))
												user.totals.otherJobs[type] = 0

											user.totals.allJobs[type] += parseFloat(userRecord.totals[type])

											if (innerJob.id != job.id || innerJob.type != job.type) 
												//add it to other jobs total if this doesn't match with current job
												user.totals.otherJobs[type] += parseFloat(userRecord.totals[type])
											
										})
										user.totals.allJobs.total += parseFloat(userRecord.totals.total)

										if (innerJob.id != job.id || innerJob.type != job.type)
											user.totals.otherJobs.total += parseFloat(userRecord.totals.total)
									}

								})
							})
						}
					})
				}
			})

			return payPeriods
		},
		///////////////////////////////////////////////////////////////////////
		// The following methods are abstractions for getPayPeriodsFromLogs()
		///////////////////////////////////////////////////////////////////////
		createNewUserObj(log, daysObj) {

			let unionName = "Unclassified"
			if (log.User.EmployeeClassification && log.User.EmployeeClassification.length > 0 && "Union" in log.User.EmployeeClassification[0] && log.User.EmployeeClassification[0].Union)
				unionName = log.User.EmployeeClassification[0].Union.union_name
			else if (log.User.EmployeeClassification) 
				unionName = log.User.EmployeeClassification.title

			return {
				id: log.User.id,
				fullName: log.User.first_name+" "+log.User.last_name,
				unionName,
				showUserLogsPanel: false,
				totals: {
					regular_hours: parseFloat(log.regular_hours),
					overtime_hours_15x: parseFloat(log.overtime_hours_15x),
					overtime_hours_2x: parseFloat(log.overtime_hours_2x),
					overtime_hours_25x: parseFloat(log.overtime_hours_25x),
					total: parseFloat(log.regular_hours) + parseFloat(log.overtime_hours_15x) + parseFloat(log.overtime_hours_2x) + parseFloat(log.overtime_hours_25x)
				},
				days: daysObj
			}
		},
		createNewJobObj(jobs,log,daysObj) {
			let vm = this

			//to figure out if this job is reviewable by this user, find the job in jobs, and see if the user is assigned with review_timelogs permission

			let reviewable = false
			let hasReviewer = false

			jobs.forEach(job => {

				if ((job.id == log.job_id && job.type == "project") || (job.id == log.service_id && job.type == "service")) {

					job.JobPersonnelRole.forEach(role => {

						if (vm.$store.userDetails.id == role.user_id && role.review_timelogs == 1) {
							reviewable = true
							hasReviewer = false
						}

						if (role.review_timelogs == 1)
							hasReviewer = true
						
					})

					if (!hasReviewer && vm.$store.company.managing_user_id == vm.$store.userDetails.id)
						reviewable = true
				}
			})

			let customerName = ""
			let jobType = ""
			let type = ""
			let job_id

			if (log.Job) {
				jobType = "Job"
				type = "project"
				job_id = log.job_id

			}
			else if (log.Service) {
				jobType = "Service"
				type = "service"
				job_id = log.service_id
			}
			else
				return false

			if ("Customer" in log[jobType] && log[jobType].Customer && "name" in log[jobType].Customer)
				customerName = log[jobType].Customer.name
			else if ("customer_name_cache" in log[jobType])
				customerName = log[jobType].customer_name_cache

			let user = vm.createNewUserObj(log,daysObj)

			let users = []
			if (user)
				users = [user]

			return {
				id: job_id,
				type: type,
				job_name: log[jobType].job_name,
				job_num: log[jobType].job_num,
				pays_perdiem: log[jobType].pays_perdiem,
				pays_mileage: log[jobType].pays_mileage,
				slug: log[jobType].slug,
				reviewable: reviewable,
				noReviewManager: !hasReviewer,
				customerName,
				users
			}
		},
		//this returns an array of "days" in a pay period, with the passed in log assiged to to the day it belongs to
		createNewDayObj(periodStartDate, daysInPeriod, log) {
			let vm = this
			let days = []

			let iteratedDay = new Date(periodStartDate)

			for (var d = 0; d < daysInPeriod; d++) {
				let logs = []

				let dayDate = new Date(periodStartDate).setDate(new Date(periodStartDate).getDate() + d)

				let label = vm.dayOfWeekNames[new Date(dayDate).getDay()] + " " + vm.monthNames[new Date(dayDate).getMonth()] + " " + new Date(dayDate).getDate()

				log.timeOnlyIn = vm.formatDateTimeToLocal(log.time_in,'time')
				log.timeOnlyOut = vm.formatDateTimeToLocal(log.time_out,'time')

				let dayDateLocal = vm.moment.utc(dayDate).local().format("MMM D, YYYY")
				let logDateLocal = vm.moment.utc(log.time_in).local().format("MMM D, YYYY")

				//only push log if it matches the day
				if (dayDateLocal == logDateLocal) 
					logs.push(log)

				days.push({
					date: dayDateLocal,
					label,
					logs
				})
			}

			return days
		},
		/////////////////////////////////////////////////////////////
		// Expense Helpers
		/////////////////////////////////////////////////////////////
		/**
		*[{
		*	label: "Feb 12 to Feb 19",
		*	start: YYYY-MM-DD,
		*	end: YYYY-MM-DD,
		*	projectName: string,
		*	projectNum: string,
		*	users: [
		*		{
		*			id: 1,
		*			fullName: "Bob Test",
		*			total: 12.00,
		*			expenses: [
		*				{expense}
		*			]	
		*		}
		*	]
		*}]
		**/
		mutateExpensesToPayperiods(expenses, payPeriodInterval, initial_payday) {
			let vm = this

			if (expenses.length == 0)
				return []

			let daysInPeriod = this.findNumDaysinPayPeriod(expenses[0].purchase_date,payPeriodInterval,initial_payday)
			let payPeriods = []

			expenses.forEach(expense => {

				let periodStartDate = vm.findPayRollStartDay(expense.purchase_date,payPeriodInterval,initial_payday)

				if (periodStartDate) {
					let periodEndDate = new Date(periodStartDate)

					periodEndDate.setDate(periodStartDate.getDate() + daysInPeriod)

					let payPeriodFound = false
					payPeriods.forEach(period => {
						let periodStart = vm.formatDateToSystem(vm.findPayRollStartDay(expense.purchase_date,payPeriodInterval,initial_payday))

						if (periodStart == period.start) {
							payPeriodFound = true

							//search for users
							let userFound = false
							period.users.forEach(user => {

								if (user.id == expense.user_id) {
									userFound = true

									user.expenses.push(vm.mutateExpense(expense))
									user.total += parseFloat(expense.cost)
								}

							})
							if (!userFound) {
								period.users.push(vm.createNewExpenseUserObj(expense))
							}
						}

					})
					if (!payPeriodFound) {

						let startDate = new Date(periodStartDate)
						let endDate = new Date(periodEndDate)
						endDate.setDate(endDate.getDate() - 1)

						let labelStart = vm.monthNames[startDate.getMonth()] + " " + startDate.getDate()

						let labelEnd = vm.monthNames[endDate.getMonth()] + " " + endDate.getDate()

						payPeriods.push({
							label: labelStart + " to " + labelEnd,
							start: vm.formatDateToSystem(periodStartDate),
							end: vm.formatDateToSystem(periodEndDate),
							users: [vm.createNewExpenseUserObj(expense)]
						})
					}
				}

			})

			return payPeriods
		},
		createNewExpenseUserObj(expense) {
			let vm = this

			return {
				id: expense.User.id,
				fullName: expense.User.first_name+" "+expense.User.last_name,
				total: parseFloat(expense.cost),
				expenses: [vm.mutateExpense(expense)]
			}
		},
		mutateExpense(expense) {
			let vm = this

			expense.purchaseDate = vm.formatDate(expense.purchase_date)

			expense.userFullName = expense.User.first_name + " " + expense.User.last_name
			expense.expenseCodeName = expense.ExpenseCode.code

			expense.projectName = ""
			if (expense.Job) 
				expense.projectName = expense.Job.job_name
			else if (expense.Service)
				expense.projectName = expense.Service.job_name

			expense.projectNum = ""
			if (expense.Job)
				expense.projectNum = expense.Job.job_num
			else if (expense.Service)
				expense.projectNum = expense.Service.job_num

			if (expense.ExpenseGroup)
				expense.expenseGroupName = expense.ExpenseGroup.group_name
			else if ('ExpenseGroup' in expense.ExpenseCode && expense.ExpenseCode.ExpenseGroup) 
				expense.expenseGroupName = expense.ExpenseCode.ExpenseGroup.group_name
			else
				expense.expenseGroupName = ""

			expense.receiptImageLink = ""
			if ("ReceiptImage" in expense && expense.ReceiptImage) {
				expense.receiptImageLink = "<a target='_blank' href='" + window.apiRoot + "resources/receipt-images/" + vm.$store.sessionToken + "/" + expense.ReceiptImage.filename + "'><i class='fa fa-file-text'></i> Receipt</a>"
			
				expense.receiptImageLink += "&nbsp; <a target='_blank' href='" + window.apiRoot + "resources/receipt-images/" + vm.$store.sessionToken + "/" + expense.ReceiptImage.filename + "?download=true'><i class='fa fa-download'></i></a>"
			}

			if (expense.ReviewedBy) {
				expense.reviewedByName = expense.ReviewedBy.first_name+ " "+expense.ReviewedBy.last_name

				expense.approvedIcon = expense.approved == 1 ? "<i class='fa fa-check'></i>" : "<i class='fa fa-times'></i>"
			}
			else {
				expense.reviewedByName = ""
				expense.approvedIcon = ""
			}

			expense.totalCost = 0
			let subtotal = parseFloat(expense.cost)
			if (!isNaN(subtotal))
				expense.totalCost += subtotal

			let tax = parseFloat(expense.tax)
			if (!isNaN(tax))
				expense.totalCost += tax

			let tip = parseFloat(expense.tip)
			if (!isNaN(tip))
				expense.totalCost += tip

			expense.totalCost = expense.totalCost.toCurrency()
			
			expense.shortDeniedReason = expense.denied_reason.substring(0,12)+"..."

			if ("PurchaseOrder" in expense && expense.PurchaseOrder && "Supplier" in expense.PurchaseOrder && expense.PurchaseOrder.Supplier)
				expense.vendor = expense.PurchaseOrder.Supplier.name
			else if ("Supplier" in expense && expense.Supplier)
				expense.vendor = expense.Supplier.name

			return expense
			
		},
		createPayBoostLabel(payBoosts) {
			let payBoostLabel = ""
			if (payBoosts) {
				payBoosts.forEach(pb => {
					if (pb.description)
						payBoostLabel += pb.description + " "
				})
			}
			return payBoostLabel
		},
		addPayrollLine(log,type,caName,caId,rateLabel,hourlyRate) {
			let vm = this

			let logDate = vm.moment.utc(log.time_in).local().format("YYYY-MM-DD")
			
			let job_name, job_id, job_type, job_num, job_slug, job
			let jobRole = ""

			if (log.Job) {
				job_name = log.Job.job_name
				job_num = log.Job.job_num
				job_id = log.job_id
				job_type = "Job"
				job_slug = log.Job.slug
				job = log.Job
			}
			else if (log.Service) {
				job_name = log.Service.job_name
				job_id = log.service_id
				job_num = log.Service.job_num
				job_type = "Service"
				job_slug = log.Service.slug
				job = log.Service
			} 

			let truncatedJobName = job_name
			if (job_name.length > 25)
				truncatedJobName = job_name.substr(0,25)+"..."

			let jobLabel = job_num+": "+truncatedJobName

			let days = {}

			days[logDate] = parseFloat(log[type])

			let lineTotal = 0

			for (var day in days) {
				lineTotal += parseFloat(days[day])
			}

			//get color
			let textColor = "black"
			vm.unionList.forEach(union => {
				union.CollectiveAgreement.forEach(ca => {
					if (ca.id == caId)
						textColor = union.text_color
				})
			})

			let payboost_list = []
			let payBoostExplanationsText = "", payBoostExplanations = []
			if (log.PayBoost) {
				log.PayBoost.forEach(pb => {

					payboost_list.push(pb.id)

					let payBoostExplanation = "<em>"+pb.description+"</em>: "

					let dollarSign = "$", percentSign = "", pbLogTotal = 0
					if (pb.is_percent == 1) {
						dollarSign = ""
						percentSign = "%"
					}

					if (pb.is_perdiem == 1) {
						payBoostExplanation += "Flat rate "
						pbLogTotal = +pb.amount
					}
					else
						payBoostExplanation += "Increase of <strong>"+dollarSign+pb.amount+percentSign+"</strong>"

					if (pb.is_perdiem == 0) {
						payBoostExplanation += "/hr = "

						if (pb.is_percent == 0)
							pbLogTotal = lineTotal * +pb.amount
						else 
							pbLogTotal = lineTotal * +pb.amount / 100 * hourlyRate
					}
					payBoostExplanation += " <strong>$"+pbLogTotal.toCurrency()+" extra</strong>"

					payBoostExplanations.push(payBoostExplanation)
				})

				if (payBoostExplanations.length > 0)
					payBoostExplanationsText = "<ul><li>"+payBoostExplanations.join("</li><li>")+"</li></ul>"
			}

			return {
				jobLabel,
				rateLabel,
				classification: log.classification,
				pay_boosts: payboost_list,
				payBoostExplanation: payBoostExplanationsText,
				job_name: job_name,
				job_num: job_num,
				job_id: job_id,
				job_slug: job_slug,
				jobType: job_type,
				hr_type: type,
				lineTotal: lineTotal,
				collectiveAgreeementId: caId,
				textColor: textColor,
				days: days,
				job
			}
		},
		logTypeToLabel(type,payBoosts,union_name,log) {

			let hourTypes = {
				regular_hours: "",
				overtime_hours_15x: "OT 1.5x",
				overtime_hours_2x: "OT 2x",
				overtime_hours_25x: "OT 2.5x"
			}

			let typeLabel = ""

			if (hourTypes[type])
				typeLabel = " - "+hourTypes[type]

			if (union_name)
				typeLabel = union_name + typeLabel

			let job
			if ("Job" in log && log.Job)
				job = log.Job
			else if ("Service" in log && log.Service)
				job = log.Service

			let roleLabel = false

			//check if the user was assigned to a role on this job
			if (job && typeof job.JobPersonnelRole == "object" && job.JobPersonnelRole.length > 0) {

				let matchingRole = job.JobPersonnelRole.find(role => role.user_id == log.user_id)

				if (matchingRole) {

					let classIsExluded = matchingRole.EmployeeClassification.find(ec => ec.id == log.User.EmployeeSetting[0].classification_id)

					if (!classIsExluded)
						roleLabel = matchingRole.title
				}

			}

			if (roleLabel)
				typeLabel += " - "+roleLabel

			let payBoostLabel = this.createPayBoostLabel(payBoosts)
			if (payBoostLabel)
				typeLabel += " "+payBoostLabel

			return typeLabel
		},
		mutateReport(userReport,reportRecord) {
/**
{
	id: 1,
	user_id: (int),
	record_id: (int),
	fullName: 'Chad Tiffin',
	classification: obj,
	userTotal: float,
	dailyTotals: {},
	typeTotals: {},
	caTotals: {},
	grandTotal: float,
	totalMileageKm: float,
	totalPerDiemPay: float,
	totalMileagePay: float,
	payrollLines: [
		{
			jobLabel: string
			classification: string,
			pay_boosts: array of ints,
			payboosts_label: string,
			job_name: '',
			job_num,
			customerName: '',
			customerLocationName: '',
			customer_id: ''
			job_id: (int),
			job_slug: hash,
			jobType: Job/Service
			hr_type: reg/1.5x/2x/2.5x,
			lineTotal: float,
			collectiveAgreeementId: (int),
			textColor: hexCode,
			days: {
				CURRENT 'YYYY-MM-DD': hrs
				TO-DO 'YYYY-MM-DD': {hrs: hrs, processed: true/false}
			}
			
		}
	],
	mileage: [
		{
			day: 'YYYY-MM-DD',
			job_name: string,
			job_num: string,
			job_id: int
			per_diem: {dollar amount},
			collectiveAgreement: (string),
			collectiveAgreeementId: (int),
			distance: {km},
			mileage_pay: {dollar amount}
		}
	]
}
*/			let vm = this

			let hrTypes = ["regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]

			let mutatedReport = vm.cloneObj(userReport)

			let collectiveAgreements = JSON.parse(JSON.stringify(vm.collectiveAgreements))
			let dailyTotals = {}
			let grandTotal = 0
			let caTotals = {}
			let totalMileagePay = 0
			let totalMileageKm = 0
			let totalPerDiemPay = 0

			if (!("typeTotals" in userReport))
				mutatedReport.typeTotals = {}

			vm.userNoteToggle[userReport.id] = false
			vm.userNotes[userReport.id] = ""

			let payrollLines = []
			let mileage = []

			if ("logs" in userReport && userReport.logs) {
				userReport.logs.forEach(log => {

					let logDate = vm.moment.utc(log.time_in).local().format("YYYY-MM-DD")	

					let job_id, job_name, job_num
					if ("Job" in log && log.Job) {
						job_id = log.Job.id
						job_name = log.Job.job_name
						job_num = log.Job.job_num
					}
					else if ("Service" in log && log.Service) {
						job_id = log.Service.id
						job_name = log.Service.job_name

						let internalWO = ""
						if (log.Service.internal_wo)
							internalWO = ": WO #"+log.Service.internal_wo

						job_num = log.Service.job_num+internalWO
					}

					let mileageAdded = false

					hrTypes.forEach((type,index) => {

						//make sure there is actually hours logged for this type
						if (log[type] > 0) {

							grandTotal += +log[type]

							if (!(logDate in vm.totalHrsByDay))
								vm.$set(vm.totalHrsByDay,logDate,0)

							vm.totalHrsByDay[logDate] += +log[type]

							//search payroll line for matching type, job, day & payBoost (if applicable)
							let lineFound = false, lineTotal = 0

							if (log[type] > 0 && logDate in dailyTotals)
								dailyTotals[logDate] += +log[type]
							else
								dailyTotals[logDate] = +log[type]

							let log_ca_id
							//this is where the new format of CA's should be set (with multiple CA's per job)
							if ("collective_agreement_id" in log)
								log_ca_id = log.collective_agreement_id

							let caName = "", ca
							if (log_ca_id == 0 || !log_ca_id) {
								let classification = false
								try {
									classification = JSON.parse(log.classification_json)
								}
								catch (e) {}

								if (classification)
									caName = classification.title
								else
									caName = "Unclassified"
							}
							else {
								//set Compensation Schedule name
								ca = collectiveAgreements.find(ca => log_ca_id == ca.id)
								if (ca)
									caName = ca.title

							}

							if (!(caName in caTotals))
								caTotals[caName] = {}
							
							payrollLines.forEach(prLine => {

								let payBoostMatchesOrNotApplicable = true, payBoostLabel = ""

								if ("PayBoost" in log && log.PayBoost.length > 0) {
									//payboosts need to be searched to make sure the list matches the log's list, otherwise it belongs on a new prline

									log.PayBoost.forEach(pb => {
										if (prLine.pay_boosts.indexOf(pb.id) == -1)
											//not found
											payBoostMatchesOrNotApplicable = false
										else
											payBoostLabel += pb.description + " "
									})
								}
								else if (prLine.pay_boosts.length > 0)
									payBoostMatchesOrNotApplicable = false

								if (payBoostMatchesOrNotApplicable && log.classification == prLine.classification) {
									if (
										(prLine.job_id == log.job_id || prLine.job_id == log.service_id) && 
										type == prLine.hr_type 
									) {

										lineFound = true

										if (prLine.days[logDate])
											prLine.days[logDate] += +log[type] //add to hrs for day
										else
											prLine.days[logDate] = +log[type] //add to hrs for day

										for (var day in prLine.days) 
											lineTotal += +prLine.days[day]

										prLine.lineTotal = lineTotal

										let logTypeLabel = vm.logTypeToLabel(type,log.PayBoost,caName,log)

										if (!(logTypeLabel in mutatedReport.typeTotals))
											mutatedReport.typeTotals[logTypeLabel] = 0

										if (!(logTypeLabel in caTotals[caName]))
											caTotals[caName][logTypeLabel] = 0

										caTotals[caName][logTypeLabel] += +log[type]

										mutatedReport.typeTotals[logTypeLabel] += +log[type]

									}
								}

							})
							if (!lineFound) {

								let hourlyRate = log.hourly_rate

								let typeRateMap = {
									regular_hours: 1,
									overtime_hours_15x: 1.5,
									overtime_hours_2x: 2,
									overtime_hours_25x: 2.5
								}

								if (ca) {
									let payScales = []
									try {
										payScales = JSON.parse(ca.pay_scales)
										let logClassificationObj = JSON.parse(log.classification_json)

										let classificationScale = payScales.find(cl => cl.classification_id == logClassificationObj.id)

										if (classificationScale) {
											
											if (classificationScale.hourly_rate > 0)
												//calc from defined hourly rate
												hourlyRate = typeRateMap[type] * +classificationScale.hourly_rate
											
											else {
												//in some cases (due to inconsistency, the hourly rate may not be defined, in that case, use cost/hr)
												let costHrMap = {
													regular_hours: "cost_hr",
													overtime_hours_15x: "ot15_cost_hr",
													overtime_hours_2x: "ot2_cost_hr",
													overtime_hours_25x: "ot25_cost_hr"
												}

												let key = costHrMap[type]

												hourlyRate = +classificationScale[key]
											}
										}
									}
									catch (e) {}
								}

								let logTypeLabel = vm.logTypeToLabel(type,log.PayBoost,caName,log)

								//line doesn't exist, so we need to add another one
								let newPayrollLine = vm.addPayrollLine(log,type, caName, log_ca_id,logTypeLabel, hourlyRate)

								if (!(logTypeLabel in mutatedReport.typeTotals))
									mutatedReport.typeTotals[logTypeLabel] = 0

								if (!(logTypeLabel in caTotals[caName]))
									caTotals[caName][logTypeLabel] = 0

								caTotals[caName][logTypeLabel] += +log[type]

								mutatedReport.typeTotals[logTypeLabel] += +log[type]

								payrollLines.push(newPayrollLine)
							}

							//if mileage, push it, only on first index though because we don't want a mileage entry for each hour type!
							//also only one mileage log per project per day
							if (!mileageAdded && (log.per_diem > 0 || log.mileage_pay > 0)) {

								let logDate = vm.moment.utc(log.time_in).local().format("YYYY-MM-DD")

								let mileageExistsAlready = mileage.find(record => record.day == logDate && record.job_id == job_id)

								if (!mileageExistsAlready) {
									mileageAdded = true;
							
									let per_diem = ""
									if (!isNaN(log.per_diem) && log.per_diem != "" && +log.per_diem > 0 && log.skip_perdiem != 1)
										per_diem = parseFloat(log.per_diem).toFixed(2)

									totalPerDiemPay += +log.per_diem
									totalMileagePay += +log.mileage_pay
									totalMileageKm += +log.distance_km

									mileage.push({
										day: logDate,
										job_name: job_name,
										job_num: job_num,
										job_id: job_id,
										per_diem: per_diem,
										distance: +log.distance_km,
										collectiveAgreement: caName,
										collectiveAgreeementId: log_ca_id,
										mileage_pay: log.mileage_pay > 0 ? parseFloat(log.mileage_pay).toFixed(2) : ""
									})
								}
							}
							
						}
					})
				})
			}

			//sort by most recent days first
			payrollLines.sort((a,b) => {

				let momentList = Object.keys(a.days).map(day => vm.moment(day))

				let earliestDayA = vm.moment.min(momentList)

				momentList = Object.keys(b.days).map(day => vm.moment(day))

				let earliestDayB = vm.moment.min(momentList)

				if (earliestDayB.isAfter(earliestDayA))
					return -1

				else
					return 1
			})

			//set color on CAs
			Object.keys(caTotals).forEach(caKey => {
				caTotals[caKey].color = "#424c50"
				vm.unionList.forEach(union => {
					union.CollectiveAgreement.forEach(ca => {
						if (caKey == collectiveAgreements.find(ca2 => ca.id == ca2.id).title && union.text_color != "") {
							caTotals[caKey].color = union.text_color
						}
					})
				})
			})

			mutatedReport.caTotals = caTotals
			mutatedReport.dailyTotals = dailyTotals
			mutatedReport.grandTotal = grandTotal
			mutatedReport.payrollLines= payrollLines
			mutatedReport.mileage = mileage
			mutatedReport.totalPerDiemPay = !isNaN(totalPerDiemPay) && totalPerDiemPay > 0 ? totalPerDiemPay.toFixed(2) : ""
			mutatedReport.totalMileageKm = !isNaN(totalMileageKm) && totalMileageKm > 0 ? totalMileageKm.toFixed(1) : ""
			mutatedReport.totalMileagePay = !isNaN(totalMileagePay) && totalMileagePay > 0 ? totalMileagePay.toFixed(2) : ""
			//user.collectiveAgreements = user.collectiveAgreements

			mutatedReport.user_id = reportRecord.user_id
			mutatedReport.record_id = reportRecord.id

			mutatedReport.unionIds = []
			try {
				mutatedReport.unionIds = JSON.parse(reportRecord.user_union_ids_json)
			}
			catch (e) {}

			return mutatedReport
		},
	}
}